// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { MyProfileApi } from './my-profile.types';
import { myProfileHttpApi } from './my-profile.api';
import { myProfileMockApi } from './my-profile.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const myProfileApi: MyProfileApi = useMock ? myProfileMockApi : myProfileHttpApi;
